import React from "react";
import { FieldRenderProps } from "react-final-form";

import { Input } from "reactstrap";
import { InputType } from 'reactstrap/lib/Input'

const CheckboxInput: React.FC<FieldRenderProps<any, HTMLElement>> = ({
  input,
  id,
  isSelected,
  label,
  disabled,
  meta: { touched, error },
}) => {
  return (
    <div className="custom-control custom-checkbox myCustom-control">
      <Input
        {...input}
        type={input.type as InputType} 
        id={id}
        className="custom-control-input"
        disabled={disabled}

      />
      <label className="custom-control-label text-nowrap" htmlFor={id}>
        {label ? label : id}
      </label>
    </div>
  );
};

export default CheckboxInput;
